import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UserService } from '../../../services/user';
import { switchMap } from 'rxjs/operators';
import { User } from '../../../classes/user';
import { from } from 'rxjs';
import { RoleService } from '../../../services/role';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { HttpErrorResponse } from '@angular/common/http';
import { UserActiveModalComponent } from '../../../modals/user/user-active-modal/user-active-modal.component';
import { UserDeactiveModalComponent } from '../../../modals/user/user-deactive-modal/user-deactive-modal.component';
import { UserDeleteModalComponent } from '../../../modals/user/user-delete-modal/user-delete-modal.component';

@Component({
  selector: 'app-user-general',
  templateUrl: './user-general.component.html',
  styleUrls: ['./user-general.component.css'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class UserGeneralComponent implements OnInit {

  // Pagination Parameters
  paginationConfig = {
    itemsPerPage: 10,
    currentPage: 1
  };
  paginationParams = {
    autoHide: true,
    maxSize: 7,
    responsive: true
  };
  paginationLabels = {
    previousLabel: 'Precedente',
    nextLabel: 'Successiva',
    screenReaderPaginationLabel: 'Paginazione',
    screenReaderPageLabel: 'pagina',
    screenReaderCurrentLabel: `Sei sulla pagina`
  };

  // Filters
  userFilterValue!: string;
  usernameFilterValue!: string;
  roleFilterValue!: string;
  activeFilterValue!: string;

  // Users data
  users: Array<User> = [];

  constructor(private userService: UserService,
              private roleService: RoleService,
              private modalService: NgbModal) { }

  ngOnInit(): void {
    this.userService.getAllOrderByUsername()
      .pipe(
        switchMap((usersData: any) => from(usersData))
      )
      .subscribe({
        next: (user: any) => {
          this.users.push(user);
        },
        error: e => {
          console.log('Error: ' + e);
        }
      });
  }

  onPageChange(pageNumber: number) {
    this.paginationConfig.currentPage = pageNumber;
  }

  onPageBoundsCorrection(pageNumber: number) {
    this.paginationConfig.currentPage = pageNumber;
  }

  openActivateUserModal(user: User) {
    const modalRef = this.modalService.open(UserActiveModalComponent);
    modalRef.componentInstance.user = user;
    modalRef.result.then((userBack: User) => {
      if (userBack) {
        userBack.active = true;
        this.userService.update(userBack)
          .subscribe({
            next: (userUpdated: any) => {
              console.log(userUpdated);
            },
            error: (err: HttpErrorResponse) => {
              console.log(err);
            }
          });
      }
    });
  }

  openDeactivateUserModal(user: User) {
    const modalRef = this.modalService.open(UserDeactiveModalComponent);
    modalRef.componentInstance.user = user;
    modalRef.result.then((userBack: User) => {
      if (userBack) {
        userBack.active = false;
        this.userService.update(userBack)
          .subscribe({
            next: (userUpdated: any) => {
              console.log(userUpdated);
            },
            error: (err: HttpErrorResponse) => {
              console.log(err);
            }
          });
      }
    });
  }

  openDeleteUserModal(user: User) {
    const modalRef = this.modalService.open(UserDeleteModalComponent);
    modalRef.componentInstance.user = user;
    modalRef.result.then((userBack: User) => {
      if (userBack) {
        this.userService.delete(userBack.id_user)
          .subscribe({
            next: () => {
              this.users = this.users.filter((currUser: User) => currUser.id_user !== userBack.id_user);
              this.paginationConfig.currentPage = 1;
            },
            error: (err: HttpErrorResponse) => {
              console.log(err);
            }
          });
      }
    });
  }

}
